import { render, staticRenderFns } from "./SingleOrderCreate.vue?vue&type=template&id=36fd345b&"
import script from "./SingleOrderCreate.vue?vue&type=script&lang=js&"
export * from "./SingleOrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrderCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports